import { useParams } from "react-router-dom";
import { faCheck, faSmileBeam } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import UnForm from "../../../Components/Form";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ListarUsuariosController } from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    CriarAgendamentoPorEmailClienteVistoriaController,
    ListarHorariosDisponiveisDataDeCorteController,
} from "../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import moment from "moment";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IAgendamento } from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface URLParams {
    Token: string;
}

export default function AgendamentoPeloClienteVistoria() {
    const { Token } = useParams<URLParams>();
    const [formAtivo, setFormAtivo] = useState(true);
    const [mostrarCampos, setMostrarCampos] = useState(false);

    const [dataSelecionada, setDataSelecionada] = useState("");

    const TokenItens = atob(Token);

    const jsonTokenDecoder = JSON.parse(TokenItens);

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMostrarCampos(e.target.checked);
    };

    const {
        value: lstHorariosDisponiveisDataDeCorte,
        loading: lstHorariosDisponiveisDataDeCorteLoading,
    } = useAsyncEffect(
        () =>
            ListarHorariosDisponiveisDataDeCorteController(
                jsonTokenDecoder.ID_ORGANIZACAO,
                jsonTokenDecoder.ID_EMPREENDIMENTO,
                jsonTokenDecoder.ID_UNIDADE,
                jsonTokenDecoder.ID_USUARIO_TECNICO
            ),
        []
    );

    const {
        execute: CriarAgendamentoPorEmailCliente,
        loading: CriarAgendamentoPorEmailClienteLoading,
    } = useAsyncCallback(CriarAgendamentoPorEmailClienteVistoriaController);

    function handleFazerAgendamentoPeloCliente(formData: IAgendamento) {
        setFormAtivo(true);
        CriarAgendamentoPorEmailCliente(
            jsonTokenDecoder.ID_USUARIO_ATENDENTE ?? 0,
            jsonTokenDecoder.ID_ORGANIZACAO ?? "",
            {
                ...formData,
                ID_CASO: jsonTokenDecoder.ID_CASO,
                ID_PRODUTO: jsonTokenDecoder.ID_UNIDADE,
                DS_ASSUNTO: jsonTokenDecoder.DS_ASSUNTO,
                DS_DESCRICAO: jsonTokenDecoder.DS_DESCRICAO,
            }
        ).then(() => {
            setFormAtivo(false);
        });
    }

    return (
        <>
            <OrSpinner
                loading={lstHorariosDisponiveisDataDeCorteLoading}
                spinner="capys"
            >
                {formAtivo ? (
                    <div className="p-4">
                        <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                            <h3>Criar Agendamento</h3>
                        </div>

                        <UnForm
                            handleSubmit={handleFazerAgendamentoPeloCliente}
                            className="m-0"
                        >
                            {({ getValues, setValue }) => (
                                <div className="col-12">
                                    <div className="row m-0">
                                        <div className="col-md-4 mb-2">
                                            <UnForm.LazySelect
                                                name="ID_USUARIO"
                                                label="Atribuído a"
                                                controller={
                                                    ListarUsuariosController
                                                }
                                                getDS={(ds) => ds.DS_NOME}
                                                getKeyValue={(key) =>
                                                    key.ID_USUARIO
                                                }
                                                defaultValue={
                                                    jsonTokenDecoder.ID_USUARIO_TECNICO
                                                }
                                                registerOptions={{
                                                    required:
                                                        "Insira o técnico responsável",
                                                }}
                                                tabIndex={-1}
                                                aria-disabled={true}
                                                style={{
                                                    background: "#eee",
                                                    pointerEvents: "none",
                                                    touchAction: "none",
                                                }}
                                            >
                                                <option></option>
                                            </UnForm.LazySelect>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="dataSelect">
                                                Data
                                            </label>
                                            <UnForm.Select
                                                id="dataSelect"
                                                name="DT_CADASTRO"
                                                onChange={(e) => {
                                                    const novaData =
                                                        e.target.value;
                                                    setDataSelecionada(
                                                        novaData
                                                    );
                                                }}
                                                value={dataSelecionada}
                                            >
                                                <option></option>
                                                {lstHorariosDisponiveisDataDeCorte?.map(
                                                    (item, index) => (
                                                        <option
                                                            key={index}
                                                            value={item.Data}
                                                        >
                                                            {moment(
                                                                item.Data
                                                            ).format(
                                                                "DD/MM/YYYY"
                                                            )}
                                                        </option>
                                                    )
                                                )}
                                            </UnForm.Select>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <label htmlFor="horaSelect">
                                                Hora Inicial
                                            </label>
                                            <UnForm.Select
                                                id="horaSelect"
                                                name="HR_INICIO"
                                            >
                                                <option></option>
                                                {dataSelecionada &&
                                                    lstHorariosDisponiveisDataDeCorte
                                                        ?.find(
                                                            (item) =>
                                                                item.Data ===
                                                                dataSelecionada
                                                        )
                                                        ?.Horarios.map(
                                                            (hora, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={hora}
                                                                >
                                                                    {hora}
                                                                </option>
                                                            )
                                                        )}
                                            </UnForm.Select>
                                        </div>
                                    </div>

                                    <div className="col-12 m-0">
                                        <div className="row ">
                                            <label className="col-md-12">
                                                Local
                                            </label>
                                            <UnForm.Textarea
                                                name="DS_LOCAL"
                                                noRezise
                                                rows={4}
                                                wrapperClassName="col-12 col-md-12 m-0"
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <div className="col-md-3">
                                            <div className="row m-0">
                                                <UnForm.Switch
                                                    color="success"
                                                    name="NECESSIDADE_VIZINHO.FL_VIZINHO"
                                                    type="checkbox"
                                                    label="Vizinho"
                                                    labelPosition="top"
                                                    wrapperClassName="col-12 col-md-12 m-0"
                                                    onChange={
                                                        handleCheckboxChange
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {mostrarCampos === true ? (
                                            <>
                                                <div className="col-md-3">
                                                    <div className="row m-0 ">
                                                        <label className="col-md-2 ml-4">
                                                            Nome
                                                        </label>
                                                        <UnForm.Input
                                                            name="NECESSIDADE_VIZINHO.DS_NOME"
                                                            wrapperClassName="col-12 col-md-12 m-0"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="row m-0 ">
                                                        <label className="col-md-2 ml-4">
                                                            Unidade
                                                        </label>
                                                        <UnForm.Input
                                                            name="NECESSIDADE_VIZINHO.DS_UNIDADE_VIZINHO"
                                                            wrapperClassName="col-12 col-md-12 m-0"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="row m-0 ">
                                                        <label className="col-md-2 ml-4">
                                                            Telefone
                                                        </label>
                                                        <UnForm.Input
                                                            name="NECESSIDADE_VIZINHO.NR_TELEFONE_VIZINHO"
                                                            wrapperClassName="col-12 col-md-12 m-0"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                        <UnForm.SubmitButton
                                            color="success"
                                            icon={faCheck}
                                            loading={
                                                CriarAgendamentoPorEmailClienteLoading
                                            }
                                            loadingSize="sm"
                                            type="submit"
                                            wrapperClassName="d-flex w-100 justify-content-center"
                                            className="btn btn-success font-weight-bold mr-2 w-100px"
                                        >
                                            Enviar
                                        </UnForm.SubmitButton>
                                    </div>
                                </div>
                            )}
                        </UnForm>
                    </div>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100vw",
                            overflowX: "hidden",
                        }}
                    >
                        <div className="jumbotron text-center">
                            <h1 className="display-3">Agendamento criado!</h1>
                            <p className="lead">
                                O agendamento foi feito com sucesso!
                            </p>
                            <hr />
                            <FontAwesomeIcon size="5x" icon={faSmileBeam} />
                        </div>
                    </div>
                )}
            </OrSpinner>
        </>
    );
}
